export const DATA_BANK_VIEW_PAST_ELECTION = "past_election";
export const DATA_BANK_VIEW_CASTE_SUMMARY = "caste_summary";
export const DATA_BANK_VIEW_CONSTITUENCY_MAP = "constituency_map";

export type DataBankViewType =
    | typeof DATA_BANK_VIEW_PAST_ELECTION
    | typeof DATA_BANK_VIEW_CASTE_SUMMARY
    | typeof DATA_BANK_VIEW_CONSTITUENCY_MAP;

export const DATA_BANK_VIEW_OPTIONS: { value: DataBankViewType; label: string }[] = [
    { value: DATA_BANK_VIEW_PAST_ELECTION, label: "Past election results" },
    { value: DATA_BANK_VIEW_CASTE_SUMMARY, label: "Caste summary" },
    { value: DATA_BANK_VIEW_CONSTITUENCY_MAP, label: "Constituency maps" },
];

export function isDataBankViewType(v: string): v is DataBankViewType {
    return DATA_BANK_VIEW_OPTIONS.some((o) => o.value === v);
}
